import React, { FC } from "react";

const Slider: FC<{
  name: string;
  label: string;
  status?: string;
  value?: any;
  step?: number;
  min?: number;
  max?: number;
  minLabel?: string;
  maxLabel?: string;
  disabled?: boolean;
  onChange?: any;
  getValueOnChange?: any;
}> = (props) => {
  const sliderValueChangeHandler = (targetValue: any) => {
    props.getValueOnChange && props.getValueOnChange(targetValue);
    props.onChange && props.onChange();
  };

  return (
    <div className="slider">
      <input
        name={props.name}
        placeholder={props.label}
        type="range"
        className="slider__input"
        value={props.value}
        step={props.step}
        min={props.min}
        max={props.max}
        disabled={props.disabled || false}
        // onChange={(event) => sliderValueChangeHandler(event.target.value)}
        onInput={(event: any) => sliderValueChangeHandler(event.target.value)}
      />
      <div className="slider__labels">
        <span className="text--tertiary fw--500">
          {props.minLabel ? props.minLabel : props.min}
        </span>
        <span className="text--tertiary fw--500">
          {props.maxLabel ? props.maxLabel : props.max}
        </span>
      </div>
    </div>
  );
};

export default Slider;
